import { Route, Routes } from 'react-router-dom';
import { ContentWithHeaderRoute } from '../layout/ContentWithHeaderRoute';
import { routes, SubRouteType } from '.';
import { useAuth0 } from '@auth0/auth0-react';
import { useStatelessGet } from '../utils/useStatelessGet';
import { FieldValues } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useStatelessPut } from '../utils/useStatelessPut';
import { mapZohoFieldsToForm } from '../utils/fieldMapper';
import { YourExperienceForm } from '../local-coordinator/application/experience/YourExperienceForm.tsx';
import { PersonalReferences } from '../host-family/application/personalReferences/PersonalReferences.tsx';
import { FamilyDetailsForm } from '../host-family/application/familyDetails/FamilyDetailsForm.tsx';
import { CommunityForm } from '../host-family/application/community/CommunityForm.tsx';
import { FamilyPhotosForm } from '../host-family/application/photos/FamilyPhotosForm.tsx';

export const LocalCoordinatorRoutes = () => {
  const { user } = useAuth0();

  // TODO: change this once MW endpoints are done
  const zohoApplicationId = user?.userData.zohoApplicationId;
  const getLocalCoordinatorApplication = useStatelessGet<FieldValues>(`/api/student-applications/${zohoApplicationId}`);
  const putLocalCoordinatorApplication = useStatelessPut(`/api/student-applications/${zohoApplicationId}`);
  const [applicationData, setApplicationData] = useState<FieldValues | undefined>();

  useEffect(() => {
    if (zohoApplicationId) {
      getLocalCoordinatorApplication().then((res) => setApplicationData(mapZohoFieldsToForm(res, 'hostFamily')));
    }
  }, [getLocalCoordinatorApplication, zohoApplicationId]);

  if (!routes.localCoordinator.subRoutes) return;

  const subRoutes: Record<string, SubRouteType> = routes.localCoordinator.subRoutes.reduce((acc, subRoute) => ({ ...acc, ...subRoute.routes }), {});

  return (
    <Routes>
      <Route element={<ContentWithHeaderRoute />}>
        <Route path={subRoutes.yourExperience.url} element={<YourExperienceForm />} />
        <Route
          path={subRoutes.familyDetails.url}
          element={<FamilyDetailsForm applicationData={applicationData} submitApplication={putLocalCoordinatorApplication} />}
        />
        <Route
          path={subRoutes.personalReferences.url}
          element={<PersonalReferences applicationData={applicationData} submitApplication={putLocalCoordinatorApplication} />}
        />
        <Route path={subRoutes.houseHome.url} element={<></>} />
        <Route
          path={subRoutes.community.url}
          element={<CommunityForm applicationData={applicationData} submitApplication={putLocalCoordinatorApplication} />}
        />
        <Route path={subRoutes.photos.url} element={<FamilyPhotosForm />} />
      </Route>
    </Routes>
  );
};
